module.exports = __webpack_public_path__ + "img/2@s.73175fee.jpg";